export const openHoursArray = [
  { day: 'Monday', hours: '12:00 - 22:30' },
  { day: 'Tuesday', hours: '12:00 - 22:30' },
  { day: 'Wednesday', hours: '12:00 - 22:30' },
  { day: 'Thursday', hours: '12:00 - 22:30' },
  { day: 'Friday', hours: '12:00 - 23:00' },
  { day: 'Saturday', hours: '12:00 - 23:00' },
  { day: 'Sunday', hours: '12:00 - 22:00' }
];

export const foodServiceHoursArray = [
  { day: 'Monday', hours: '12:00 - 22:00' },
  { day: 'Tuesday', hours: '12:00 - 22:00' },
  { day: 'Wednesday', hours: '12:00 - 22:00' },
  { day: 'Thursday', hours: '12:00 - 22:00' },
  { day: 'Friday', hours: '12:00 - 22:00' },
  { day: 'Saturday', hours: '12:00 - 22:00' },
  { day: 'Sunday', hours: '12:00 - 18:00' }
];